<template>
  <iModal
    :close-on-backdrop="false"
    :close-on-escape="false"
    :close-on-secondary="false"
    :content-height="80"
    :max-width="900"
    :show-footer="false"
    scrollable
    title="Assign Publishing Platform"
    width="fill"
    @close="close"
  >
    <template #body>
      <iColumn>
        <iTitle>
          Publications
        </iTitle>
        <iRow>
          <template v-if="publications.length === 0">
            <iText variant="subtle">
              You have no active publications.
            </iText>
          </template>
          <template v-else>
            <iStyledCard
              v-for="publication in publications"
              :key="publication.publicationId"
              :max-width="270"
              :splash-image="publication.publicationLogo || DEFAULT_SPLASH_IMAGE"
              :splash-image-max-height="100"
              :title="publication.name"
              width="fill"
            >
              <template #footer>
                <iButton
                  variant="secondary"
                  width="fill"
                  @click="handleSelectPlatform(PUBLISHING_PLATFORM_TYPE.PUBLICATION, publication.publicationId)"
                >
                  Select
                </iButton>
              </template>
            </iStyledCard>
          </template>
        </iRow>
      </iColumn>
    </template>
  </iModal>
</template>

<script>
import { PUBLISHING_PLATFORM_TYPE } from "%/constants/story-constants";
import { useSocialNetworksStore } from "@/stores/social-networks-store";
import { STORY_VARIANT_TYPES } from "@/constants/story-variant-type-constants";
import { DEFAULT_SPLASH_IMAGE } from "%/constants/publication-constants";
import { socialNetworkConnectionStatus } from "@/enums/social-network-enums";
import { useActivePublicationFeedStore } from "SmartFeed/stores/feed/active-publication-feed-store";
import SmartFeedEngine from "@/smart-feed/smart-feed-engine";

export default {
  name: "AssignSyndicatedPublishingPlatformModal",
  props: {
    storyId: {
      type: [Number, String],
      required: false,
      default: "",
    },
  },
  emits: ["close", "change"],
  data() {
    return {
      PUBLISHING_PLATFORM_TYPE,
      STORY_VARIANT_TYPES,
      DEFAULT_SPLASH_IMAGE,
    };
  },
  computed: {
    publications() {
      const usePublicationEntityStoreFunction = SmartFeedEngine.getEntityPiniaStore("publication");
      return usePublicationEntityStoreFunction().entities;
    },
    socialNetworks() {
      return useSocialNetworksStore().socialNetworks.filter(network => [
        socialNetworkConnectionStatus.CONNECTED,
        socialNetworkConnectionStatus.MANUAL_CONNECTION,
      ].includes(network.status));
    },
  },
  mounted() {
    useActivePublicationFeedStore().getSmartFeed();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleSelectPlatform(type, id) {
      this.$emit("change", this.getEntity(type, id));
    },
    getEntity(type, id) {
      const publication = this.publications[id];
      const network = this.socialNetworks.find(socialNetwork => socialNetwork.social_network_account_id === id);
      switch (type) {
        case PUBLISHING_PLATFORM_TYPE.PUBLICATION:
          return {
            publishing_platform_id: publication.publicationId,
            publishing_platform_type: PUBLISHING_PLATFORM_TYPE.PUBLICATION,
            publishing_platform_name: publication.name,
          };
        case PUBLISHING_PLATFORM_TYPE.SOCIAL_NETWORK:
          return {
            publishing_platform_id: network.social_network_account_id,
            publishing_platform_type: PUBLISHING_PLATFORM_TYPE.SOCIAL_NETWORK,
            publishing_platform_name: network.social_network_name,
          };
        case PUBLISHING_PLATFORM_TYPE.EMAIL:
          return {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
